import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@backslashbuild/pp-ui";
import {
  Content,
  PageTitle,
  PanelColumn,
  PageHeadingArea,
  PanelColumnSet,
} from "@backslashbuild/pp-ui";

import AgencyDetailsForm from "../modules/agencies/AgencyDetailsForm";

export default function Agency() {
  const { id } = useParams();

  return (
    <Content scrollable>
      <PageHeadingArea>
        <PageTitle>Edit Agency Details</PageTitle>
      </PageHeadingArea>

      <PanelColumnSet>
        <PanelColumn>
          <AgencyDetailsForm id={id} />
        </PanelColumn>
      </PanelColumnSet>
    </Content>
  );
}
